import hash from 'object-hash';
import { getFetcherRequestLogger } from './utils';
import { SWRFetcherRequest } from './swr';
import { ROEFetcherRequest } from './roe';
import { PollingFetcherRequest } from './polling';
export class RequestFactory {
    constructor(requestCreator) {
        this.requestControl = new RequestControlImpl(requestCreator);
    }
    getRequest(options, request) {
        var _a;
        const cacheKey = (_a = options === null || options === void 0 ? void 0 : options.cacheKey) !== null && _a !== void 0 ? _a : hash(request !== null && request !== void 0 ? request : null, { algorithm: 'md5', respectType: false });
        if (typeof options.pollingWaitTime === 'number') {
            return new PollingFetcherRequest(this.requestControl, cacheKey, options, request, getFetcherRequestLogger('polling', options, cacheKey, request));
        }
        if (options.retryTimes > 0) {
            return new ROEFetcherRequest(this.requestControl, cacheKey, options, request, getFetcherRequestLogger('swr', options, cacheKey, request));
        }
        return new SWRFetcherRequest(this.requestControl, cacheKey, options, request, getFetcherRequestLogger('swr', options, cacheKey, request));
    }
}
class RequestControlImpl {
    constructor(requestCreator) {
        this.requestCreator = requestCreator;
        this.instanceByKey = new Map();
    }
    getResponse(cacheKey, request) {
        let instance = this.instanceByKey.get(cacheKey);
        if (!instance) {
            let abortController;
            if (typeof AbortController !== 'undefined') {
                abortController = new AbortController();
            }
            const signal = abortController === null || abortController === void 0 ? void 0 : abortController.signal;
            instance = {
                response: this.requestCreator(request, { signal }),
                refCount: 0,
                abortController,
            };
            this.instanceByKey.set(cacheKey, instance);
            instance.response
                .catch(() => {
                /* do nothing */
            })
                .then(() => {
                this.instanceByKey.delete(cacheKey);
            });
        }
        instance.refCount += 1;
        return instance.response;
    }
    release(cacheKey) {
        var _a;
        const instance = this.instanceByKey.get(cacheKey);
        if (!instance) {
            return;
        }
        instance.refCount -= 1;
        if (instance.refCount === 0) {
            this.instanceByKey.delete(cacheKey);
            (_a = instance.abortController) === null || _a === void 0 ? void 0 : _a.abort();
        }
    }
}
